export default "__VITE_ASSET__6pP1WVWT__"